"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../date");
const message_1 = require("./message");
const createD2CMessage = (namespace, alarms) => {
    const Alarm = effect_1.Schema.Union(...alarms.map(Alarm => {
        const { _tag, fields: { _tag: tagField, ...fields }, } = Alarm;
        const LegacyAlarm = effect_1.Schema.Struct({
            alarmName: tagField,
            time: date_1.MillisecondsSinceEpoch,
            ...fields,
        });
        const RaiseAlarm = effect_1.Schema.encodedBoundSchema(LegacyAlarm)
            .pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
            action: effect_1.Schema.optionalWith(effect_1.Schema.Literal('raise'), {
                exact: true,
                default: () => 'raise',
            }),
        })))
            .annotations(effect_1.Record.getSomes({
            title: effect_1.SchemaAST.getTitleAnnotation(Alarm.ast).pipe(effect_1.Option.map(title => `Raise: ${title}`)),
        }));
        const DismissAlarm = effect_1.Schema.encodedBoundSchema(LegacyAlarm)
            .pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
            action: effect_1.Schema.tag('dismiss'),
        })))
            .annotations(effect_1.Record.getSomes({
            title: effect_1.SchemaAST.getTitleAnnotation(Alarm.ast).pipe(effect_1.Option.map(title => `Dismiss: ${title}`)),
        }));
        const DismissAnyAlarm = effect_1.Schema.encodedBoundSchema(LegacyAlarm)
            .pipe(effect_1.Schema.pick('alarmName', 'time'), effect_1.Schema.extend(effect_1.Schema.Struct({
            action: effect_1.Schema.tag('dismissAny'),
        })))
            .annotations(effect_1.Record.getSomes({
            title: effect_1.SchemaAST.getTitleAnnotation(Alarm.ast).pipe(effect_1.Option.map(title => `Dismiss Any: ${title}`)),
        }));
        return effect_1.Schema.Union(RaiseAlarm.pipe(effect_1.Schema.transform(effect_1.Schema.TaggedStruct('Raise', {
            time: date_1.Timestamp,
            alarm: effect_1.Schema.asSchema(Alarm),
        }), {
            strict: true,
            decode: ({ action, time, alarmName, ...alarm }) => ({
                _tag: 'Raise',
                time,
                alarm: { _tag: alarmName, ...alarm },
            }),
            encode: ({ time, alarm: { _tag: alarmTag, ...alarm } }) => ({
                action: 'raise',
                time,
                alarmName: alarmTag,
                ...alarm,
            }),
        })), DismissAlarm.pipe(effect_1.Schema.transform(effect_1.Schema.TaggedStruct('Dismiss', {
            time: date_1.Timestamp,
            alarm: effect_1.Schema.asSchema(Alarm),
        }), {
            strict: true,
            decode: ({ action, time, alarmName, ...alarm }) => ({
                _tag: 'Dismiss',
                time,
                alarm: { _tag: alarmName, ...alarm },
            }),
            encode: ({ time, alarm: { _tag, ...alarm } }) => ({
                action: 'dismiss',
                time,
                alarmName: _tag,
                ...alarm,
            }),
        })), DismissAnyAlarm.pipe(effect_1.Schema.transform(effect_1.Schema.TaggedStruct('DismissAny', {
            time: date_1.Timestamp,
            alarm: effect_1.Schema.TaggedStruct(_tag, {}),
        }), {
            strict: true,
            decode: ({ time, alarmName }) => ({
                _tag: 'DismissAny',
                time,
                alarm: { _tag: alarmName },
            }),
            encode: ({ time, alarm: { _tag } }) => ({
                action: 'dismissAny',
                time,
                alarmName: _tag,
            }),
        })));
    }));
    const DismissAllAlarms = effect_1.Schema.transform(effect_1.Schema.Struct({
        action: effect_1.Schema.tag('dismissAll'),
        time: effect_1.Schema.encodedBoundSchema(date_1.Timestamp),
    }).annotations({
        title: 'Dismiss All Alarms',
    }), effect_1.Schema.TaggedStruct('DismissAll', {
        time: date_1.Timestamp,
    }), {
        strict: true,
        decode: ({ time }) => ({
            _tag: 'DismissAll',
            time,
        }),
        encode: ({ time }) => ({
            action: 'dismissAll',
            time,
        }),
    });
    return (0, message_1.createMessage)('alarm', effect_1.Schema.Union(Alarm, DismissAllAlarms)).annotations({
        identifier: `${namespace}.AlarmD2CMessage`,
        title: 'Alarm Message',
        description: 'A Device-To-Cloud message on the "alarm" channel',
    });
};
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=alarm.js.map